

export const permissionMixin = {
    methods: {

    },
    computed: {
        isAdmin: function () {
            if (!this.$store.getters.adminUser) {
                return false;
            }
            return this.$store.getters.adminUser.super_user;
        }
    }
}